/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const FolderIcon = ({
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path d="M14 2.667H8.233L5.733.8c-.1-.1-.266-.133-.4-.133H2c-1.1 0-2 .9-2 2v10.667c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4.667c0-1.1-.9-2-2-2zM2 2h3.1l2.5 1.867c.1.1.267.133.4.133h6c.367 0 .667.3.667.667V6H1.333V2.667C1.333 2.3 1.633 2 2 2zm12 12H2a.669.669 0 01-.667-.666v-6h13.334v6c0 .366-.3.666-.667.666z" />
  </CreateIconComponent>
);

export default FolderIcon;
